// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"AppSpinner_spinnerWrapper__3DI9k"};